<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header [title]="'Informatie'"></app-modal-header>
    <div class="modal-body">
        <div class="row mt-2">
            <div class="col-6">
                <table class="table table-striped">
                    <tr>
                        <td width="100" class="text-muted">
                            Client
                        </td>
                        <td>
                            {{item['client']['name']}}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-muted">
                            Type
                        </td>
                        <td>
                            {{item['type']}}
                        </td>
                    </tr>
                </table>
            </div>
            <div class="col-3">
                <table class="table table-striped">
                    <tr>
                        <td width="100" class="text-muted">
                            Verkeer
                        </td>
                        <td>
                            <span class="p-0" *ngIf="item['incoming'] == 1">
                                Inkomend
                            </span>
                            <span class="p-0" *ngIf="item['incoming'] == 0">
                                Uitgaand
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td width="100" class="text-muted">
                            Status
                        </td>
                        <td>
                            <span class="p-0" *ngIf="item['processed'] == 1">
                                Verwerkt
                            </span>
                            <span class="p-0" *ngIf="item['processed'] == 0">
                                Niet verwerkt
                            </span>
                            <span class="p-0" *ngIf="item['error_process']">
                                <i class="bi bi-exclamation-diamond-fill text-danger"></i>
                            </span>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="col-3">
                <table class="table table-striped">
                    <tr>
                        <td width="100">
                            Datum
                        </td>
                        <td>
                            {{item['created_at'] | dutchDate}}
                        </td>
                    </tr>
                    <tr>
                        <td width="100">
                            Tijd
                        </td>
                        <td>
                            {{item['created_at'] | date: 'HH:mm' }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-6">
                <div class="py-2 fw-bold">Body</div>
                <textarea class="form-control" style="height:600px;font-size:70%;">{{ formatJson(item['content']) }}</textarea>
            </div>
            <div class="col-3">
                <div class="py-2 fw-bold">Response</div>
                <textarea class="form-control" style="height:600px;font-size:70%;">{{ formatJson(item['response_body']) }}</textarea>
            </div>
            <div class="col-3">
                <div class="py-2 fw-bold">Error</div>
                <textarea class="form-control" style="height:600px;font-size:70%;">{{ formatJson(item['error_message']) }}</textarea>
            </div>
        </div>
    </div>
    <div class="p-5">
        <div class="form-buttons">
            <button type="button" (click)="process()" class="btn btn-primary" *ngIf="item['incoming'] == 1">
                Verwerk
            </button>
            <button type="button" (click)="process()" class="btn btn-primary" *ngIf="item['incoming'] == 0">
                Verstuur
            </button>
            <button type="button" (click)="reset()" class="btn btn-primary">
                Reset verwerkstatus
            </button>
        </div>
    </div>
</div>